import resolveConfig from 'tailwindcss/resolveConfig';
import _ from 'lodash';
// @ts-ignore: Importing config file as relative path
import tailwindConfig from '../tailwind.config';

const resolvedConfig = resolveConfig(tailwindConfig);

const getTailwindColor = (color: string, shade: string | number | undefined = undefined): string => {
    const colors = resolvedConfig.theme.colors;
    const foundColor = _.get(colors, color);
    if (!foundColor) {
        return '';
    }

    if (shade && foundColor[Number(shade)]) {
        return foundColor[Number(shade)];
    }

    return foundColor;
};

export default getTailwindColor;
